import { ClientEvents } from 'common/events/ClientEvents';
import { isUndefined } from 'lodash';
import React from 'react';
import { ConsumerGroupOrderFieldsFragment, GroupOrderReviewStatus } from 'src/gqlReactTypings.generated.d';
import { OrdersListRowButton } from 'src/pages/consumer/account/orders/styles';
import { useTracker } from 'src/shared/hooks/useTracker';

interface Props {
  groupOrder: ConsumerGroupOrderFieldsFragment;
  showReviewModal?: () => void;
}

export const ReviewButton = ({ groupOrder, showReviewModal }: Props) => {
  const { id, canReviewOrder, review } = groupOrder;
  const tracker = useTracker();

  if (!canReviewOrder || isUndefined(showReviewModal)) {
    return null;
  }

  return (
    <OrdersListRowButton
      onClick={(event: React.MouseEvent<HTMLButtonElement>) => {
        event.preventDefault();
        tracker.track(ClientEvents.REVIEW_GROUP_ORDER_BUTTON_CLICK, { groupOrderId: id });
        showReviewModal();
      }}>
      {review.status === GroupOrderReviewStatus.Started ? 'Edit Review' : 'Review'}
    </OrdersListRowButton>
  );
};
